<template>
  <div ref="turnstileWidget"></div>
</template>

<script>
export default {
  name: 'CloudflareTurnstileWidget',
  props: {
    theme: {
      type: String,
      default: 'light',
      validator: value => ['light', 'dark', 'auto'].includes(value)
    },
    size: {
      type: String,
      default: 'normal',
      validator: value => ['normal', 'compact', 'flexible'].includes(value)
    },
    siteKey: {
      type: String,
      default: process.env.VUE_APP_TURNSTILE_SITE_KEY
    }
  },
  data() {
    return {
      turnstileWidgetId: null,
      scriptId: 'cf-turnstile-script'
    }
  },
  mounted() {
    this.loadTurnstile()
  },
  beforeDestroy() {
    if (window.turnstile && this.turnstileWidgetId !== null) {
      window.turnstile.remove(this.turnstileWidgetId)
    }
  },
  methods: {
    loadTurnstile() {
      if (window.turnstile) {
        this.renderTurnstile()
        return
      }

      let script = document.getElementById(this.scriptId)

      if (!script) {
        script = document.createElement('script')
        script.id = this.scriptId
        script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit'
        script.async = true
        script.defer = true
        document.head.appendChild(script)
      }

      script.addEventListener('load', this.renderTurnstile)
      script.addEventListener('error', () => {
        this.onTurnstileError('Falha ao carregar o script do Turnstile.')
      })
    },
    renderTurnstile() {
      if (this.turnstileWidgetId !== null) return

      if (window.turnstile && this.$refs.turnstileWidget) {
        try {
          this.turnstileWidgetId = window.turnstile.render(this.$refs.turnstileWidget, {
            sitekey: this.siteKey,
            theme: this.theme,
            size: this.size,
            callback: this.onTurnstileSuccess,
            'error-callback': this.onTurnstileError,
            'expired-callback': this.onTurnstileExpired
          })
        } catch (err) {
          this.onTurnstileError(err?.message || 'Erro ao renderizar Turnstile')
        }
      }
    },
    onTurnstileError(message) {
      console.error('[Turnstile] Error: ', message)
      this.$emit('error', message)

      if (this.$snackbar) {
        this.$snackbar({
          message: 'Não foi possível carregar a verificação. Verifique sua conexão ou extensões bloqueadoras.',
          snackbarColor: 'error'
        })
      }
    },
    onTurnstileSuccess(token) {
      this.$emit('success', token)
    },
    onTurnstileExpired() {
      this.$emit('expired')
    },
    reset() {
      if (window.turnstile && this.turnstileWidgetId !== null) {
        window.turnstile.reset(this.turnstileWidgetId)
      }
    }
  }
}
</script>
